import {isGamanzaUiEnabled} from "@/utils/gamanzaUi";
import {useAuthStore} from "@/store/useAuth.store";
import {getGamanzaPlayerStats} from "./gamanza/gamanzaPlayer.service";

const EMPTY_GAMER_PROFILE = {
  points: 0,
  tokens: 0,
  level: 0,
  rankName: null,
  xpBalance: 0,
  levelProgress: null,
  pointsUntilNextLevel: null,
};

/**
 * Gamification summary for navbar / profile.
 * Prefers Gamanza Frontend API when enabled; otherwise returns zeros.
 */
export const getMyProfileGamerService = async () => {
  if (!isGamanzaUiEnabled()) {
    return {data: {data: EMPTY_GAMER_PROFILE}};
  }

  const identityToken = useAuthStore.getState().token;
  if (!identityToken) {
    return {data: {data: EMPTY_GAMER_PROFILE}};
  }

  try {
    const stats = await getGamanzaPlayerStats(identityToken);
    return {data: {data: stats}};
  } catch (error) {
    console.warn("[gamanza] failed to load player stats:", error?.message || error);
    return {data: {data: EMPTY_GAMER_PROFILE}};
  }
};
